import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const SERVICES_CONTANTS = {
  SERVICES_TITLE: "Servicios",
  PAGE_TITLE: "Consulta de pacientes",
  HELP_TEXT:
    "En esta sección solo estaran listados los servicios que no requiren de orden para ser asignados, para asignar un servicio con orden podra hacerlo desde el flujo de crear orden",
  BUTTON: {
    ASSIGN_SERVICE: "Asignar servicio",
    SEE_SESSIONS: "Ver sesiones",
    COMPLETE_SERVICE: "Completar servicio",
    CANCEL_SERVICE: "Cancelar Servicio",
    VIEW_SERVICE_NOTES: "Mostrar Notas"
  },
  LABEL: {
    ASSIGN_PRICE_LEVEL: "Asignar nivel de precio",
    ASSIGNED_SERVICES: "Servicios asignados",
    STATE: "Estado: ",
    CATEGORY: "Categoría: ",
    TYPE: "Tipo: ",
    CUPS: "CUPS: ",
    DESCRIPTION: "Descripción: ",
    SELECT_PRICE_LEVEL: "Seleccione un nivel de precio*",
    USER_TYPE: "Tipo de usuario",
    CONTRACT_TYPE: "Tipo de contrato",
    CHARGE_CONCEPT: "Concepto de recaudo",
    ATTENTION_TYPE: "Modalidad de atención",
    ASSIGN_SERVICE: "Asignación de servicio*",
    ASSIGN_GROUP: "Asignación de Grupo",
    ASSIGN_SECTION: "Asignación de Sección",
    SESSIONS: "Sesiones",
    FORM_TEMPS: "Formularios",
    PERSONALIZED_STATE: "Personalizado",
    SCHEDULE_APPOINTMENT: "Agendar cita",
    APPOINTMENT_DETAIL: "Detalles cita",
    EXTERNAL_ORDER_NUMBER: "Número Externo",
    CLEAN_GROUPS: "Limpiar",
    CUPS_FIELD: "Cups"
  },
  MESSAGE: {
    ASSIGNED: "Se ha asignado el servicio",
    ASSIGN_FAILED: "No se ha asignado el servicio",
    EMPTY_HEADER: "No hay servicios asignados para mostrar",
    EMPTY_PARAGRAPH: "Asigne un servicio al usuario en la pestaña de búsqueda",
    NO_ORDER_FOUND:
      "No tiene orden asociada, debe crear una orden de servicio primero.",
    NO_ID: "No se pudo cargar el id del servicio",
    SELECT_ASSIGN_GROUP: "Seleccione un tipo de asignación al grupo",
    SELECT_ASSIGN_SECTION: "Seleccione un tipo de asignación de la sección",
    SELECT_ASSIGN_SERVICE: "Seleccione un tipo de asignación del servicio",
    SELECT_SESSIONS: "Seleccione sesiones",
    SELECT_FORM_TEMPS: "Seleccione formularios",
    REQUIRED_PRIOR_ORDER:
      "El servicio requiere una orden para asignar una cita",
    UPDATE_FAILED: "Hubo un error actualizando el servicio"
  },
  STATE: {
    ASSIGNED: "Asignado"
  },
  ATTRIBUTES: ["name", "price"],
  NAME_ROLE_PATIENT: "Paciente",
  IDS: {
    UPDATE_SERVICES: "updateServices",
    SUCCESS: "success"
  }
};

export const SERVICE_STATES = {
  NOT_ASSIGNED: "Sin asignar",
  NOT_START: "Sin Iniciar",
  ASSIGNED: "Asignado",
  PROGRESS: "En progreso",
  COMPLETED: "Completado",
  CANCELED: "Cancelado",
  TEMPORARY: "Temporal",
  INVOICE: "Facturado",
  STAND_BY: "En espera"
};

export const SERVICE_TYPES = {
  SECTIONS_KEY: "sections",
  GROUPS_KEY: "groups",
  SECTIONS_NAME: "Sección",
  GROUPS_NAME: "Grupo",
  SERVICE_STATE_KEY: "active",
  SERVICE_STATE_NOT_ACTIVE_KEY: "nonActive",
  SERVICE_STATE_NAME: "Habilitado",
  SERVICE_STATE_NOT_ACTIVE_NAME: "Deshabilitado"
};

export const SERVICE_STATES_ARRAY = [
  SERVICE_STATES.ASSIGNED,
  SERVICE_STATES.CANCELED,
  SERVICE_STATES.COMPLETED,
  SERVICE_STATES.PROGRESS,
  SERVICE_STATES.NOT_ASSIGNED
];

export const SERVICE_STATE_COLORS = {
  "Sin asignar": "#8C97A1",
  Asignado: "#63c7e7",
  "En progreso": "#FDFD96",
  Completado: "#69D1C5",
  Cancelado: "#F7A072"
};

export const SERVICES_ORDER_TO_SHOW = [
  SERVICE_STATES.PROGRESS,
  SERVICE_STATES.ASSIGNED,
  SERVICE_STATES.NOT_ASSIGNED,
  SERVICE_STATES.NOT_START,
  SERVICE_STATES.STAND_BY
];

export const SERVICES_ORDER_TO_NOT_SHOW = [
  SERVICE_STATES.CANCELED,
  SERVICE_STATES.COMPLETED
];
export const SERVICES_TO_FILL = [
  "En progreso",
  "Asignado",
  "Completado",
  "Sin Iniciar",
  "Cancelado",
  "Sin asignar"
];

export const COMPLETE_SERVICE_TO_FILL = ["Completado", "Cancelado"];

export const SERVICE_CATEGORY = {
  THERAPY: "Terapia",
  CONSULTATION: "Consulta"
};

export const MODAL_CONFIRMATION_MESSAGE = {
  TITLE: "Verificación",
  TEXT: "Ya tiene este servicio agregado, desea añadirlo de todas formas?"
};

export const SERVICES_STATE = {
  COMPLETED: "Completado"
};

export const TYPE_SERVICES_OPTIONS = [
  { key: "sections", name: "Secciones" },
  { key: "groups", name: "Grupos" }
];

export const DEFAULT_CATEGORY_SERVICE_OPTION = [{ key: "otro", name: "otro" }];

export const FILTERS_NAME = {
  NAME: "internalName",
  CATEGORY: "category",
  STATUS: "state"
};

export const SERVICE_FILTERS: Filter[] = [
  {
    mainFilterKey: "service",
    mainFilterName: "Servicios",
    avatar: "mdi-shape-plus",
    initial: true,
    placeholder: "Seleccione los filtros deseados para los Servicios",
    secondaryFilters: [
      {
        name: "Nombre",
        placeholder: "Nombre de Servicio",
        key: "name",
        display: "unique",
        default: true,
        operators: OPERATORS_FILTERS,
        type: "secondaryFilter"
      },
      {
        default: false,
        name: "Categoria",
        placeholder: "Categoria de Servicio",
        key: "category",
        type: "secondaryFilter",
        display: "list",
        operators: OPERATORS_FILTERS,
        options: []
      },
      {
        default: false,
        name: "Tipo",
        placeholder: "Tipo de Servicio",
        key: "type",
        type: "secondaryFilter",
        display: "list",
        options: TYPE_SERVICES_OPTIONS,
        operators: OPERATORS_FILTERS
      }
    ]
  }
];

export const SERVICE_LIST_IDS = {
  CATEGORY: "BPQCt1csjU5JBHjVP6pt",
  USER_TYPE: "puplXlZL3IFZrmyau19r",
  CONTRACT_TYPE: "A4EYH7gPrwfDCIQvZS0Y",
  CHARGE_CONCEPT: "nFNgmGpoNyTIHEbUXB3G",
  ATTENTION_TYPE: "f6ZwoKyG0aIhuhk5h7hO"
};

export const SERVICES_ACCESS = {
  GET: "consultar servicios",
  POST: "crear servicios",
  PUT: "modificar servicios",
  DELETE: "eliminar servicios"
};

export const CANCEL_SERVICE_ORDER_STATES = ["Nueva", "Autorizada", "Asignada"];
export const CANCELED_SERVICE_BANNED_STATES = [
  SERVICE_STATES.COMPLETED,
  SERVICE_STATES.CANCELED
];
